module.exports = __webpack_public_path__ + "img/box-gif-still.bd1ab6db.png";